import { Record, Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { lambda_type, unit_type, array_type, class_type, bool_type, option_type, int32_type, record_type, list_type, union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { Modal, Intent, Model__GetCurrentContractType_789D039B, Model__GetCurrentContract, SubscriptionsMsg, Page, Page$reflection, NumberStatus, NumberStatus_GetNumberStatus, NumberStatus$reflection } from "./Model.js";
import { InvoiceeDetails$reflection, ContractType$reflection, PendingNumberForContract$reflection, SubscriptionListPhoneNumber$reflection, Contract$reflection } from "../Invoicee/Common.js";
import { uncurry, compareArrays, stringHash, arrayHash, equalArrays, int32ToString, comparePrimitives, equals } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { BillingIntervalModule_toInt, Product, ProductModule_ofInt, ContractCurrentStateModule_toTranslation, ContractCurrentState, ContractCurrentStateModule_fromString } from "../../DomainTypes.js";
import { fold, empty as empty_2, FSharpMap__TryFind, tryFind, map } from "../../fable_modules/fable-library.3.7.20/Map.js";
import { optToStr, Locale_get_FromSelectedLanguage, formatUrl, stackClasses, classNames, truncateWithEllipsis } from "../../Utils.js";
import { cons, tryFind as tryFind_1, singleton as singleton_1, toArray, exists, tryHead, sortByDescending, isEmpty, append as append_1, length, ofArray, filter, empty, sortBy, map as map_1 } from "../../fable_modules/fable-library.3.7.20/List.js";
import { printf, toText, isNullOrWhiteSpace, join } from "../../fable_modules/fable-library.3.7.20/String.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { map as map_2, defaultArg, bind, value as value_7 } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { dotsLoading, MaterialIcon_render_Z384F8060, MaterialIcon_render_12EF8ABE, getMaterialIcon, Color, getStatusBall } from "../../ViewUtils.js";
import * as react from "react";
import { LoadState_zip, GlobalDependencies$reflection, LoadState_defaultValue, getTranslationFrom, LoadState$2$reflection } from "../../Global.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { List_except, List_distinctBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";
import { op_UnaryNegation_Int32 } from "../../fable_modules/fable-library.3.7.20/Int32.js";
import { RouterModule_encodeParts, RouterModule_urlSegments } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { warning, error, info } from "../../Components/Message/Message.js";
import { renderScrollableTable } from "../../Components/Table/Table.js";
import { unEscape } from "../../Utilities/String.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { SwitchProps, SwitchProps_get_GetDefault, render as render_1 } from "../../Components/Switch/Switch.js";
import { loadContractTypesThunk } from "../../Api/Contract.js";
import { useFeliz_React__React_useElmish_Static_78C5B8C8 } from "../../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";
import { update, init } from "./Update.js";
import { SubscriptionOverviewProps, renderSubscriptionOverview } from "./Overview.js";
import { FeesProps, renderFeesSection } from "../ContractFees/View.js";
import { Cmd_OfFunc_result } from "../../fable_modules/Fable.Elmish.3.1.0/cmd.fs.js";
import { AttributesProps, renderAttributes } from "../ContractAttributes/View.js";
import { FrozenMonthsProps, view as view_1 } from "../FrozenMonths/View.js";
import { TelecomProps, view as view_2 } from "../Telecom/View.js";
import { ContractHistoryProps, renderContractHistory } from "../ContractHistory/View.js";
import { TrafficProps, view as view_3 } from "../Traffic/View.js";
import { ContractSubproductsProps, renderContractSubproducts } from "../ContractSubproducts/View.js";
import { create, delete$, update as update_1, load } from "../ContractSubproducts/Api.js";
import { singleton as singleton_2 } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { Result_Map } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { ContractSubproduct_ToDTO_Z1109ED7D, AllSubproductsResponse_FromDTO_3E78A01F } from "../ContractSubproducts/Model.js";
import { loadSubproductDefinitions } from "../SubproductDefinition/Api.js";
import { CreateSubscriptionProps, renderCreateSubscriptionModal } from "../CreateSubscription/View.js";
import { saveContract } from "../CreateSubscription/Api.js";
import { toString } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { modal } from "../../Components/Modal/Modal.js";
import { MessageType, render as render_2 } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import "../../../src/Containers/Subscriptions/View.scss";


export class PhoneNumberType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PhoneNumber", "NumberSeries"];
    }
}

export function PhoneNumberType$reflection() {
    return union_type("Containers.Subscriptions.View.PhoneNumberType", [], PhoneNumberType, () => [[["Item1", string_type], ["Item2", NumberStatus$reflection()]], [["Item1", string_type], ["Item2", string_type], ["Item3", NumberStatus$reflection()]]]);
}

export class ContractWithDisplay extends Record {
    constructor(PhoneNumberTypes, Contract, SubscriptionType, SearchFriendlyString) {
        super();
        this.PhoneNumberTypes = PhoneNumberTypes;
        this.Contract = Contract;
        this.SubscriptionType = SubscriptionType;
        this.SearchFriendlyString = SearchFriendlyString;
    }
}

export function ContractWithDisplay$reflection() {
    return record_type("Containers.Subscriptions.View.ContractWithDisplay", [], ContractWithDisplay, () => [["PhoneNumberTypes", list_type(PhoneNumberType$reflection())], ["Contract", Contract$reflection()], ["SubscriptionType", string_type], ["SearchFriendlyString", string_type]]);
}

function isNotCancelledContract(contract) {
    return !equals(ContractCurrentStateModule_fromString(contract.CurrentState), new ContractCurrentState(3));
}

function getContractsWithDisplay(phoneNumbers, contracts, contractTypes, showAllSubscriptions) {
    const contractTypeMap = map((contractTypeCode, contractType) => truncateWithEllipsis(30, contractType.Display), contractTypes);
    return map_1((contract) => {
        let contract_1, separator, phoneNumberStr;
        let phoneNumberType;
        const matchValue = tryFind(contract.ContractNumber, phoneNumbers);
        phoneNumberType = ((matchValue != null) ? map_1((number) => {
            if (number.NumberFrom === number.NumberTo) {
                return new PhoneNumberType(0, number.NumberFrom, NumberStatus_GetNumberStatus(number.ActiveFrom, number.ActiveTo));
            }
            else {
                return new PhoneNumberType(1, number.NumberFrom, number.NumberTo, NumberStatus_GetNumberStatus(number.ActiveFrom, number.ActiveTo));
            }
        }, sortBy((n) => n.NumberFrom.length, matchValue, {
            Compare: comparePrimitives,
        })) : empty());
        let subscriptionType;
        const matchValue_1 = FSharpMap__TryFind(contractTypeMap, contract.ContractTypeCode);
        subscriptionType = ((matchValue_1 == null) ? contract.ContractTypeCode : matchValue_1);
        return new ContractWithDisplay(phoneNumberType, contract, subscriptionType, (contract_1 = contract, (separator = "|", (phoneNumberStr = join(separator, map_1((phoneNumberType_1) => {
            let pattern_matching_result, numberFrom;
            if (phoneNumberType_1.tag === 1) {
                pattern_matching_result = 0;
                numberFrom = phoneNumberType_1.fields[0];
            }
            else {
                pattern_matching_result = 0;
                numberFrom = phoneNumberType_1.fields[0];
            }
            switch (pattern_matching_result) {
                case 0: {
                    return numberFrom;
                }
            }
        }, phoneNumberType)), join(separator, toList(delay(() => append(singleton(int32ToString(contract_1.ContractNumber).toLocaleLowerCase()), delay(() => append(singleton(subscriptionType.toLocaleLowerCase()), delay(() => append((contract_1.EndUser != null) ? singleton(value_7(contract_1.EndUser).toLocaleLowerCase()) : empty_1(), delay(() => append(singleton(phoneNumberStr), delay(() => ((contract_1.ClientCrossRef != null) ? singleton(value_7(contract_1.ClientCrossRef).toLocaleLowerCase()) : empty_1()))))))))))))))));
    }, filter((contract_2) => {
        if (showAllSubscriptions) {
            return true;
        }
        else {
            return isNotCancelledContract(contract_2);
        }
    }, contracts));
}

function renderContractStatusBall(getTranslation, contractState) {
    return getStatusBall((contractState.tag === 1) ? (new Color(0)) : ((contractState.tag === 3) ? (new Color(2)) : ((contractState.tag === 4) ? (new Color(2)) : ((contractState.tag === 2) ? (new Color(1)) : (new Color(0))))), ContractCurrentStateModule_toTranslation(getTranslation, contractState));
}

function renderSimCardIcon(getTranslation, numberStatus) {
    const title = (numberStatus.tag === 2) ? getTranslation("Common.Inactive") : ((numberStatus.tag === 1) ? getTranslation("Common.Pending") : getTranslation("Common.Active"));
    const classes = classNames(ofArray([["subscriptions__sim-icon", true], ["subscriptions__sim-icon--green", equals(numberStatus, new NumberStatus(0))], ["subscriptions__sim-icon--orange", equals(numberStatus, new NumberStatus(1))]]));
    const simCardIcon = getMaterialIcon("sim_card");
    return react.createElement("span", {
        className: classes,
        title: title,
    }, simCardIcon);
}

export class ContractListProps extends Record {
    constructor(CurrentContractNr, IsTelecom, SubscriptionListPhoneNumbers, PendingPhoneNumbers, Contracts, ContractTypes, ShowCancelledSubscriptions, RouterNavigateFn, ShowNumberInfoFn) {
        super();
        this.CurrentContractNr = CurrentContractNr;
        this.IsTelecom = IsTelecom;
        this.SubscriptionListPhoneNumbers = SubscriptionListPhoneNumbers;
        this.PendingPhoneNumbers = PendingPhoneNumbers;
        this.Contracts = Contracts;
        this.ContractTypes = ContractTypes;
        this.ShowCancelledSubscriptions = ShowCancelledSubscriptions;
        this.RouterNavigateFn = RouterNavigateFn;
        this.ShowNumberInfoFn = ShowNumberInfoFn;
    }
}

export function ContractListProps$reflection() {
    return record_type("Containers.Subscriptions.View.ContractListProps", [], ContractListProps, () => [["CurrentContractNr", option_type(int32_type)], ["IsTelecom", bool_type], ["SubscriptionListPhoneNumbers", LoadState$2$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, list_type(SubscriptionListPhoneNumber$reflection())]), string_type)], ["PendingPhoneNumbers", LoadState$2$reflection(list_type(PendingNumberForContract$reflection()), string_type)], ["Contracts", list_type(Contract$reflection())], ["ContractTypes", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, ContractType$reflection()])], ["ShowCancelledSubscriptions", bool_type], ["RouterNavigateFn", lambda_type(array_type(string_type), unit_type)], ["ShowNumberInfoFn", lambda_type(int32_type, unit_type)]]);
}

const renderContractList = FunctionComponent_Of_Z5A158BBF((props) => {
    let props_35, children_34, props_46, children_43;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const searchFilterState = react.useState("");
    const scrollableTableContainerRef = react.useRef(void 0);
    const scrollableTableRef = react.useRef(void 0);
    const adjustBorderRadiusState = react.useState(false);
    const filteredRows = react.useMemo(() => {
        const contractsWithDisplay = getContractsWithDisplay(LoadState_defaultValue(empty_2(), props.SubscriptionListPhoneNumbers), props.Contracts, props.ContractTypes, props.ShowCancelledSubscriptions);
        if (!isNullOrWhiteSpace(searchFilterState[0])) {
            return filter((c) => (c.SearchFriendlyString.indexOf((searchFilterState[0]).toLocaleLowerCase()) >= 0), contractsWithDisplay);
        }
        else {
            return contractsWithDisplay;
        }
    }, [props.SubscriptionListPhoneNumbers, props.Contracts, props.ContractTypes, props.ShowCancelledSubscriptions, searchFilterState[0]]);
    react.useEffect(() => {
        let arg;
        const matchValue = [scrollableTableContainerRef.current, scrollableTableRef.current];
        let pattern_matching_result, table, tableContainer;
        if (matchValue[0] != null) {
            if (matchValue[1] != null) {
                pattern_matching_result = 0;
                table = matchValue[1];
                tableContainer = matchValue[0];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const tableContainerHeight = tableContainer.clientHeight;
                arg = (table.clientHeight > tableContainerHeight);
                break;
            }
            case 1: {
                arg = false;
                break;
            }
        }
        adjustBorderRadiusState[1](arg);
    }, [filteredRows, scrollableTableContainerRef.current, scrollableTableRef.current]);
    const shouldRenderNumber_1 = props.IsTelecom;
    let contractNrHeadingHtml;
    const children_26 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Contract")];
    contractNrHeadingHtml = react.createElement("th", {
        className: "subscriptions__table-head",
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Contract",
    }, ...children_26);
    let subscriptionFormHeaderHtml;
    const children_28 = [getTranslation("CustomerContract.Invoicee.Subscriptions.SubscriptionForm")];
    subscriptionFormHeaderHtml = react.createElement("th", {
        className: "subscriptions__table-head",
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.SubscriptionForm",
    }, ...children_28);
    let numberHeaderHtml;
    if (shouldRenderNumber_1) {
        const children_30 = [getTranslation("Common.Number")];
        numberHeaderHtml = react.createElement("th", {
            className: "subscriptions__table-head",
            ["data-translation"]: "Common.Number",
        }, ...children_30);
    }
    else {
        numberHeaderHtml = react.createElement(react.Fragment, {});
    }
    const contractPageSize = 7;
    let subscriptionSearchHtml;
    if (length(props.Contracts) <= contractPageSize) {
        subscriptionSearchHtml = react.createElement(react.Fragment, {});
    }
    else {
        const children_36 = [(props_35 = [new HTMLAttr(65, "search__input"), new HTMLAttr(128, getTranslation("Common.Search")), ["data-translation", "Common.Search"], new HTMLAttr(99, "subscription-search-input"), new DOMAttr(9, (event) => {
            searchFilterState[1](Browser_Types_Event__Event_get_Value(event));
        })], react.createElement("input", keyValueList(props_35, 1))), (children_34 = [getMaterialIcon("search")], react.createElement("div", {
            className: "search__icon",
        }, ...children_34))];
        subscriptionSearchHtml = react.createElement("div", {
            className: "subscriptions__search",
        }, ...children_36);
    }
    const rows = map_1((contract) => {
        let matchValue_1, props_3, children_2, children, props_10;
        const rowClasses = classNames(ofArray([["subscriptions__table-row", true], ["subscriptions__table-row--active", (matchValue_1 = props.CurrentContractNr, (matchValue_1 != null) && (contract.Contract.ContractNumber === matchValue_1))]]));
        let contractNumberCellHtml;
        const children_4 = [(props_3 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))], (children_2 = [(children = [renderContractStatusBall(getTranslation, ContractCurrentStateModule_fromString(contract.Contract.CurrentState))], react.createElement("div", {
            className: "mr-2",
        }, ...children)), int32ToString(contract.Contract.ContractNumber)], react.createElement("div", keyValueList(props_3, 1), ...children_2)))];
        contractNumberCellHtml = react.createElement("td", {
            className: "subscriptions__table-cell",
        }, ...children_4);
        let subscriptionTypeCellHtml;
        let endUserHtml;
        const matchValue_2 = contract.Contract.EndUser;
        let pattern_matching_result_1, endUser_1;
        if (matchValue_2 != null) {
            if (!isNullOrWhiteSpace(matchValue_2)) {
                pattern_matching_result_1 = 0;
                endUser_1 = matchValue_2;
            }
            else {
                pattern_matching_result_1 = 1;
            }
        }
        else {
            pattern_matching_result_1 = 1;
        }
        switch (pattern_matching_result_1) {
            case 0: {
                const children_6 = [truncateWithEllipsis(24, endUser_1)];
                endUserHtml = react.createElement("div", {
                    className: "table-cell__end-user",
                }, ...children_6);
                break;
            }
            case 1: {
                endUserHtml = react.createElement(react.Fragment, {});
                break;
            }
        }
        const children_11 = [(props_10 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "flex-column"])))], react.createElement("div", keyValueList(props_10, 1), contract.SubscriptionType, endUserHtml))];
        subscriptionTypeCellHtml = react.createElement("td", {
            className: "subscriptions__table-cell",
        }, ...children_11);
        let phoneNumberCellHtml;
        if (shouldRenderNumber_1) {
            const phoneNumberTypes = map_1((phoneNumberType) => {
                if (phoneNumberType.tag === 1) {
                    return [toText(printf("%s - %s"))(phoneNumberType.fields[0])(phoneNumberType.fields[1]), phoneNumberType.fields[2]];
                }
                else {
                    return [phoneNumberType.fields[0], phoneNumberType.fields[1]];
                }
            }, contract.PhoneNumberTypes);
            let phoneNumbersHtml;
            const numbers = List_distinctBy((tupledArg_4) => tupledArg_4[0], append_1(List_except(map_1((tupledArg_3) => [tupledArg_3[0], new NumberStatus(1)], phoneNumberTypes), map_1((p_1) => [p_1.Number, new NumberStatus(1)], filter((p) => (p.ContractNr === contract.Contract.ContractNumber), LoadState_defaultValue(empty(), props.PendingPhoneNumbers))), {
                Equals: equalArrays,
                GetHashCode: arrayHash,
            }), phoneNumberTypes), {
                Equals: (x_2, y_2) => (x_2 === y_2),
                GetHashCode: stringHash,
            });
            if (isEmpty(numbers)) {
                phoneNumbersHtml = "";
            }
            else {
                let primaryNumberAndSimIconHtml;
                const numbers_1 = sortByDescending((tupledArg_2) => [tupledArg_2[1], op_UnaryNegation_Int32(tupledArg_2[0].length)], numbers, {
                    Compare: compareArrays,
                });
                const infoIconHtml = (length(numbers_1) > 1) ? MaterialIcon_render_12EF8ABE("info", (_arg) => {
                    props.ShowNumberInfoFn(contract.Contract.ContractNumber);
                }) : react.createElement(react.Fragment, {});
                const primaryNumberOpt = tryHead(exists((tupledArg) => equals(tupledArg[1], new NumberStatus(0)), numbers_1) ? filter((tupledArg_1) => equals(tupledArg_1[1], new NumberStatus(0)), numbers_1) : numbers_1);
                const patternInput = (primaryNumberOpt == null) ? ["", react.createElement(react.Fragment, {})] : [primaryNumberOpt[0], renderSimCardIcon(getTranslation, primaryNumberOpt[1])];
                const primaryNumberStr = patternInput[0];
                const children_17 = [patternInput[1], react.createElement("span", {
                    className: "subscriptions__phone-numbers",
                    title: primaryNumberStr,
                }, primaryNumberStr), infoIconHtml];
                primaryNumberAndSimIconHtml = react.createElement("span", {
                    className: "d-flex",
                }, ...children_17);
                const props_20 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-end"])))];
                phoneNumbersHtml = react.createElement("div", keyValueList(props_20, 1), primaryNumberAndSimIconHtml);
            }
            phoneNumberCellHtml = react.createElement("td", {
                className: "subscriptions__table-cell",
            }, phoneNumbersHtml);
        }
        else {
            phoneNumberCellHtml = react.createElement(react.Fragment, {});
        }
        return react.createElement("tr", {
            className: rowClasses,
            onClick: (_arg_1) => {
                props.RouterNavigateFn(toArray(formatUrl(RouterModule_urlSegments(window.location.hash, 1), singleton_1("Subscriptions"), singleton_1(int32ToString(contract.Contract.ContractNumber)))));
            },
        }, contractNumberCellHtml, subscriptionTypeCellHtml, phoneNumberCellHtml);
    }, filteredRows);
    const scrollableTableContainerClasses = classNames(ofArray([["subscriptions__table", true], ["subscriptions__table--scroll", adjustBorderRadiusState[0]]]));
    let contractsScrollingTableHtml;
    if (isEmpty(rows)) {
        contractsScrollingTableHtml = info(getTranslation("CustomerContract.Invoicee.Subscriptions.ContractsMissing").split(""));
    }
    else {
        const children_38 = [renderScrollableTable(ofArray([contractNrHeadingHtml, subscriptionFormHeaderHtml, numberHeaderHtml]), rows, 10, "subscriptions-contract-listing", scrollableTableRef)];
        contractsScrollingTableHtml = react.createElement("div", {
            className: scrollableTableContainerClasses,
            id: "subscriptions-table",
            ref: scrollableTableContainerRef,
        }, ...children_38);
    }
    const children_45 = [(props_46 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "mb-3"])))], (children_43 = toList(delay(() => append(singleton(subscriptionSearchHtml), delay(() => {
        let props_44, children_41;
        return (length(props.Contracts) <= contractPageSize) ? singleton(react.createElement(react.Fragment, {})) : singleton((props_44 = [new HTMLAttr(65, stackClasses(singleton_1("ml-2")))], (children_41 = [MaterialIcon_render_Z384F8060("help", unEscape(getTranslation("CustomerContract.Invoicee.Subscriptions.SearchContractInfo")))], react.createElement("div", keyValueList(props_44, 1), ...children_41))));
    })))), react.createElement("div", keyValueList(props_46, 1), ...children_43))), contractsScrollingTableHtml];
    return react.createElement("div", {
        className: "subscriptions__container",
    }, ...children_45);
}, "ContractList", Helpers_equalsButFunctions, void 0, "renderContractList", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\View.fs", 411);

export class SwitchAndButtonProps extends Record {
    constructor(IsChecked, CreateFn, ToggleSwitchFn) {
        super();
        this.IsChecked = IsChecked;
        this.CreateFn = CreateFn;
        this.ToggleSwitchFn = ToggleSwitchFn;
    }
}

export function SwitchAndButtonProps$reflection() {
    return record_type("Containers.Subscriptions.View.SwitchAndButtonProps", [], SwitchAndButtonProps, () => [["IsChecked", bool_type], ["CreateFn", lambda_type(unit_type, unit_type)], ["ToggleSwitchFn", lambda_type(unit_type, unit_type)]]);
}

const renderSwitchAndButtonHtml = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2, children;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const children_4 = [wrappedButton(new ButtonKind(0), new ButtonProps(getTranslation("Common.CreateSubscription"), defaultProps.Content, (_arg) => {
        props.CreateFn();
    }, defaultProps.Disabled, "create-subscription-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)), (children_2 = [(children = [getTranslation("CustomerContract.Invoicee.Subscriptions.ShowCancelledSubscriptions")], react.createElement("span", {
        className: "mr-2",
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.ShowCancelledSubscriptions",
    }, ...children)), render_1(new SwitchProps("subscription-show-cancelled-subscriptions", props.IsChecked, (_arg_1) => {
        props.ToggleSwitchFn();
    }, SwitchProps_get_GetDefault().IsDisabled))], react.createElement("div", {
        className: "d-flex align-items-center",
        ["data-regression"]: "subscription-show-all-switch-container",
    }, ...children_2))];
    return react.createElement("div", {
        className: "subscriptions__button-and-filter",
    }, ...children_4);
}, "SwitchAndButton", Helpers_equalsButFunctions, void 0, "renderSwitchAndButtonHtml", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\View.fs", 447);

export class NavigationProps extends Record {
    constructor(CurrentUrlSegments, BaseSegments, ShowContractAttributes, ContractNr, CurrentSubscriptionPage, FrozenMonthConfigured, UsesSubproduct, ContractType) {
        super();
        this.CurrentUrlSegments = CurrentUrlSegments;
        this.BaseSegments = BaseSegments;
        this.ShowContractAttributes = ShowContractAttributes;
        this.ContractNr = (ContractNr | 0);
        this.CurrentSubscriptionPage = CurrentSubscriptionPage;
        this.FrozenMonthConfigured = FrozenMonthConfigured;
        this.UsesSubproduct = UsesSubproduct;
        this.ContractType = ContractType;
    }
}

export function NavigationProps$reflection() {
    return record_type("Containers.Subscriptions.View.NavigationProps", [], NavigationProps, () => [["CurrentUrlSegments", list_type(string_type)], ["BaseSegments", list_type(string_type)], ["ShowContractAttributes", bool_type], ["ContractNr", int32_type], ["CurrentSubscriptionPage", Page$reflection()], ["FrozenMonthConfigured", bool_type], ["UsesSubproduct", bool_type], ["ContractType", option_type(ContractType$reflection())]]);
}

const renderNavigation = FunctionComponent_Of_Z5A158BBF((props) => {
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const getNavigationClasses = (section, currentSection) => {
        if (equals(section, currentSection)) {
            return "subscriptions__navigation-cell subscriptions__navigation-cell--active";
        }
        else {
            return "subscriptions__navigation-cell";
        }
    };
    let patternInput;
    const matchValue = props.ContractType;
    if (matchValue != null) {
        const product = ProductModule_ofInt(matchValue.ProductNr);
        patternInput = [equals(product, new Product(2)), equals(product, new Product(1)), equals(product, new Product(0)), equals(product, new Product(3))];
    }
    else {
        patternInput = [false, false, false, false];
    }
    const isVoIP = patternInput[0];
    const isTab = patternInput[1];
    const isMobileBroadband = patternInput[3];
    const isMobile = patternInput[2];
    const overviewUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Overview")), 1);
    const feesUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Fees")), 1);
    const attributesUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Attributes")), 1);
    const telecomUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Telecom")), 1);
    const historyUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("History")), 1);
    const trafficUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Traffic")), 1);
    const otherUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Other")), 1);
    const subproductUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("Subproduct")), 1);
    const frozenMonthsUrl = RouterModule_encodeParts(formatUrl(props.CurrentUrlSegments, props.BaseSegments, singleton_1("FrozenMonths")), 1);
    const children_32 = toList(delay(() => {
        let children_2, props_1, children;
        return append(singleton((children_2 = [(props_1 = [new HTMLAttr(99, "subscription-navigation-overview"), new HTMLAttr(65, getNavigationClasses(new Page(1, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "Common.Overview"]], (children = [getTranslation("Common.Overview")], react.createElement("div", keyValueList(props_1, 1), ...children)))], react.createElement("a", {
            className: "subscriptions__navigation-link col-auto",
            href: overviewUrl,
        }, ...children_2))), delay(() => {
            let children_6, props_5, children_4;
            return append(singleton((children_6 = [(props_5 = [new HTMLAttr(99, "subscription-navigation-fees"), new HTMLAttr(65, getNavigationClasses(new Page(2, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "CustomerContract.Invoicee.Subscriptions.Fees"]], (children_4 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Fees")], react.createElement("div", keyValueList(props_5, 1), ...children_4)))], react.createElement("a", {
                className: "subscriptions__navigation-link col-auto",
                href: feesUrl,
            }, ...children_6))), delay(() => {
                let children_10, props_9;
                return append(props.ShowContractAttributes ? singleton((children_10 = [(props_9 = [new HTMLAttr(99, "subscription-navigation-fees"), new HTMLAttr(65, getNavigationClasses(new Page(3, props.ContractNr), props.CurrentSubscriptionPage))], react.createElement("div", keyValueList(props_9, 1), "Attribut"))], react.createElement("a", {
                    className: "subscriptions__navigation-link col-auto",
                    href: attributesUrl,
                }, ...children_10))) : empty_1(), delay(() => {
                    let children_14, props_13, children_12;
                    return append(props.FrozenMonthConfigured ? singleton((children_14 = [(props_13 = [new HTMLAttr(99, "subscription-navigation-frozen-months"), new HTMLAttr(65, getNavigationClasses(new Page(4, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "CustomerContract.Invoicee.Subscriptions.FrozenMonths"]], (children_12 = [getTranslation("CustomerContract.Invoicee.Subscriptions.FrozenMonths")], react.createElement("div", keyValueList(props_13, 1), ...children_12)))], react.createElement("a", {
                        className: "subscriptions__navigation-link col-auto",
                        href: frozenMonthsUrl,
                    }, ...children_14))) : empty_1(), delay(() => {
                        let children_18, props_17, children_16;
                        return append((((isVoIP ? true : isTab) ? true : isMobile) ? true : isMobileBroadband) ? singleton((children_18 = [(props_17 = [new HTMLAttr(99, "subscription-navigation-telecom"), new HTMLAttr(65, getNavigationClasses(new Page(5, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "CustomerContract.Invoicee.Subscriptions.Telecom"]], (children_16 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom")], react.createElement("div", keyValueList(props_17, 1), ...children_16)))], react.createElement("a", {
                            className: "subscriptions__navigation-link col-auto",
                            href: telecomUrl,
                        }, ...children_18))) : empty_1(), delay(() => {
                            let children_22, props_21, children_20;
                            return append((((isVoIP ? true : isTab) ? true : isMobile) ? true : isMobileBroadband) ? singleton((children_22 = [(props_21 = [new HTMLAttr(99, "subscription-navigation-traffic"), new HTMLAttr(65, getNavigationClasses(new Page(7, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "CustomerContract.Invoicee.Subscriptions.Traffic"]], (children_20 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Traffic")], react.createElement("div", keyValueList(props_21, 1), ...children_20)))], react.createElement("a", {
                                className: "subscriptions__navigation-link col-auto",
                                href: trafficUrl,
                            }, ...children_22))) : empty_1(), delay(() => {
                                let children_26, props_25, children_24;
                                return append(props.UsesSubproduct ? singleton((children_26 = [(props_25 = [new HTMLAttr(99, "subscription-navigation-traffic"), new HTMLAttr(65, getNavigationClasses(new Page(8, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "CustomerContract.Invoicee.Subscriptions.Subproduct"]], (children_24 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Subproduct")], react.createElement("div", keyValueList(props_25, 1), ...children_24)))], react.createElement("a", {
                                    className: "subscriptions__navigation-link col-auto",
                                    href: subproductUrl,
                                }, ...children_26))) : empty_1(), delay(() => {
                                    let children_30, props_29, children_28;
                                    return singleton((children_30 = [(props_29 = [new HTMLAttr(99, "subscription-navigation-history"), new HTMLAttr(65, getNavigationClasses(new Page(6, props.ContractNr), props.CurrentSubscriptionPage)), ["data-translation", "CustomerContract.Invoicee.Subscriptions.History"]], (children_28 = [getTranslation("CustomerContract.Invoicee.Subscriptions.History")], react.createElement("div", keyValueList(props_29, 1), ...children_28)))], react.createElement("a", {
                                        className: "subscriptions__navigation-link col-auto",
                                        href: historyUrl,
                                    }, ...children_30)));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    }));
    return react.createElement("div", {
        id: "subscriptions-navigation",
        className: "subscriptions__navigation row no-gutters",
    }, ...children_32);
}, "Navigation", Helpers_equalsButFunctions, void 0, "renderNavigation", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\View.fs", 592);

export class SubscriptionsProps extends Record {
    constructor(GlobalDependencies, CurrentPage, InvoiceeDetails, Contracts, ReloadContractsFn, ReloadInvoiceeCurrentStateFn, ReloadInvoiceeDetailsFn) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentPage = CurrentPage;
        this.InvoiceeDetails = InvoiceeDetails;
        this.Contracts = Contracts;
        this.ReloadContractsFn = ReloadContractsFn;
        this.ReloadInvoiceeCurrentStateFn = ReloadInvoiceeCurrentStateFn;
        this.ReloadInvoiceeDetailsFn = ReloadInvoiceeDetailsFn;
    }
}

export function SubscriptionsProps$reflection() {
    return record_type("Containers.Subscriptions.View.SubscriptionsProps", [], SubscriptionsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentPage", Page$reflection()], ["InvoiceeDetails", InvoiceeDetails$reflection()], ["Contracts", LoadState$2$reflection(list_type(Contract$reflection()), string_type)], ["ReloadContractsFn", lambda_type(unit_type, unit_type)], ["ReloadInvoiceeCurrentStateFn", lambda_type(unit_type, unit_type)], ["ReloadInvoiceeDetailsFn", lambda_type(unit_type, unit_type)]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let matchValue_2, children_22;
    const reduxDispatch = useDispatch();
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const contractTypesLoadState = useSelector((state_1) => state_1.Contract.ContractTypes);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const loadContractTypes = () => {
        reduxDispatch(loadContractTypesThunk(props.GlobalDependencies.ClientNr, true));
    };
    const patternInput = useFeliz_React__React_useElmish_Static_78C5B8C8(init(props.GlobalDependencies, props.CurrentPage, props.InvoiceeDetails), (msg, model) => update(props.ReloadContractsFn, loadContractTypes, props.ReloadInvoiceeCurrentStateFn, props.ReloadInvoiceeDetailsFn, msg, model), []);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    react.useEffect(() => {
        switch (contractTypesLoadState.tag) {
            case 3: {
                loadContractTypes();
                break;
            }
            case 1:
            case 2: {
                break;
            }
            default: {
                loadContractTypes();
            }
        }
    }, []);
    react.useEffect(() => {
        dispatch(new SubscriptionsMsg(0, props.GlobalDependencies));
    }, [props.GlobalDependencies]);
    react.useEffect(() => {
        dispatch(new SubscriptionsMsg(4, props.CurrentPage));
    }, [props.CurrentPage]);
    react.useEffect(() => {
        dispatch(new SubscriptionsMsg(1, props.InvoiceeDetails));
    }, [props.InvoiceeDetails]);
    react.useEffect(() => {
        dispatch(new SubscriptionsMsg(3, props.Contracts));
    }, [props.Contracts]);
    react.useEffect(() => {
        switch (contractTypesLoadState.tag) {
            case 3:
            case 1:
            case 2: {
                break;
            }
            default: {
                loadContractTypes();
            }
        }
    }, [contractTypesLoadState]);
    const globalDeps = model_1.GlobalDependencies;
    const locale = Locale_get_FromSelectedLanguage()(globalDeps.SelectedLanguage);
    let errorMessageHtml;
    const matchValue = model_1.ErrorMessage;
    if (matchValue == null) {
        errorMessageHtml = react.createElement(react.Fragment, {});
    }
    else {
        const msg_1 = matchValue;
        const children = [error(msg_1.split(""))];
        errorMessageHtml = react.createElement("div", {
            className: "mb-4",
        }, ...children);
    }
    let subscriptionDetailsSectionHtml;
    const matchValue_1 = model_1.CurrentSubscriptionContractNr;
    if (matchValue_1 != null) {
        const contractNr = matchValue_1 | 0;
        const contractTypeOpt = bind((contract_1) => {
            const _arg = contractTypesLoadState;
            if (_arg.tag === 2) {
                return tryFind(contract_1.ContractTypeCode, _arg.fields[0]);
            }
            else {
                return void 0;
            }
        }, (matchValue_2 = model_1.Contracts, (matchValue_2.tag === 2) ? tryFind_1((contract) => (contract.ContractNumber === contractNr), matchValue_2.fields[0]) : (void 0)));
        const children_11 = toList(delay(() => append(singleton(renderNavigation(new NavigationProps(RouterModule_urlSegments(window.location.hash, 1), singleton_1(optToStr(model_1.CurrentSubscriptionContractNr)), model_1.GlobalDependencies.ClientConfig.ShowContractAttributes === true, contractNr, model_1.CurrentSubscriptionPage, model_1.FrozenMonthConfigured, model_1.GlobalDependencies.ClientConfig.UsesSubproduct === true, contractTypeOpt))), delay(() => append(singleton(errorMessageHtml), delay(() => {
            let children_9;
            const matchValue_3 = model_1.CurrentSubscriptionPage;
            switch (matchValue_3.tag) {
                case 1: {
                    return singleton(renderSubscriptionOverview(new SubscriptionOverviewProps(model_1, dispatch, matchValue_3.fields[0], model_1.InvoiceeDetails)));
                }
                case 2: {
                    const matchValue_4 = [Model__GetCurrentContract(model_1), Model__GetCurrentContractType_789D039B(model_1, contractTypesLoadState)];
                    let pattern_matching_result, contract_2, contractType;
                    if (matchValue_4[0] != null) {
                        if (matchValue_4[1] != null) {
                            pattern_matching_result = 0;
                            contract_2 = matchValue_4[0];
                            contractType = matchValue_4[1];
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                    switch (pattern_matching_result) {
                        case 0: {
                            const matchValue_5 = tryFind(contract_2.ContractNumber, model_1.Fees);
                            return (matchValue_5 != null) ? singleton(renderFeesSection(new FeesProps(matchValue_5, () => {
                                dispatch(new SubscriptionsMsg(6, contract_2.ContractNumber));
                            }, globalDeps, contract_2.ContractNumber, contractType.ContractTypeCode, contractType.ProductNr, model_1.PaymentMethod, true, BillingIntervalModule_toInt(model_1.InvoiceeDetails.MonthlyBillingInterval), true, () => {
                                dispatch(new SubscriptionsMsg(24, contract_2.ContractNumber, Cmd_OfFunc_result(new SubscriptionsMsg(39, new Intent(1)))));
                            }))) : singleton(react.createElement(react.Fragment, {}));
                        }
                        case 1: {
                            return singleton(react.createElement(react.Fragment, {}));
                        }
                    }
                }
                case 3: {
                    return singleton(renderAttributes(new AttributesProps(model_1.GlobalDependencies.ClientNr, matchValue_3.fields[0], locale)));
                }
                case 4: {
                    return singleton(view_1(new FrozenMonthsProps(globalDeps, matchValue_3.fields[0])));
                }
                case 5: {
                    const matchValue_6 = [model_1.Contracts, contractTypesLoadState];
                    let pattern_matching_result_1, contractTypes_1, contracts_1;
                    if (matchValue_6[0].tag === 2) {
                        if (matchValue_6[1].tag === 2) {
                            pattern_matching_result_1 = 0;
                            contractTypes_1 = matchValue_6[1].fields[0];
                            contracts_1 = matchValue_6[0].fields[0];
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            return singleton(view_2(new TelecomProps(globalDeps, matchValue_3.fields[0], contracts_1, contractTypes_1, () => {
                                dispatch(new SubscriptionsMsg(13, contracts_1));
                            })));
                        }
                        case 1: {
                            return singleton(react.createElement(react.Fragment, {}));
                        }
                    }
                }
                case 6: {
                    const contractNr_6 = matchValue_3.fields[0] | 0;
                    const matchValue_7 = [model_1.Contracts, contractTypesLoadState];
                    let pattern_matching_result_2, contractTypesMap, contracts_2;
                    if (matchValue_7[0].tag === 2) {
                        if (matchValue_7[1].tag === 2) {
                            pattern_matching_result_2 = 0;
                            contractTypesMap = matchValue_7[1].fields[0];
                            contracts_2 = matchValue_7[0].fields[0];
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return singleton(renderContractHistory(new ContractHistoryProps(globalDeps.ClientNr, contractNr_6, locale, contracts_2, defaultArg(map_2((contractType_1) => (contractType_1.NetworkContractNr != null), bind((contract_4) => tryFind(contract_4.ContractTypeCode, contractTypesMap), tryFind_1((contract_3) => (contract_3.ContractNumber === contractNr_6), contracts_2))), false))));
                        }
                        case 1: {
                            return singleton(react.createElement(react.Fragment, {}));
                        }
                    }
                }
                case 7: {
                    return singleton(view_3(new TrafficProps(globalDeps.ClientNr, matchValue_3.fields[0], globalDeps.CountryCode, globalDeps.ClientConfig.TelecomByteFormat)));
                }
                case 8: {
                    const contractNr_8 = matchValue_3.fields[0] | 0;
                    return singleton(renderContractSubproducts(new ContractSubproductsProps(() => {
                        const a = load(globalDeps.ClientNr, contractNr_8);
                        return singleton_2.Delay(() => singleton_2.Bind(a, (_arg_3) => singleton_2.Return(Result_Map(AllSubproductsResponse_FromDTO_3E78A01F, _arg_3))));
                    }, (name, product, activeFrom, serialNumber, subproduct) => update_1(globalDeps.ClientNr, contractNr_8, name, product, activeFrom, serialNumber, ContractSubproduct_ToDTO_Z1109ED7D(subproduct)), (name_1, product_1, activeFrom_1, serialNumber_1) => delete$(globalDeps.ClientNr, contractNr_8, name_1, product_1, activeFrom_1, serialNumber_1), (subproduct_1) => create(globalDeps.ClientNr, contractNr_8, ContractSubproduct_ToDTO_Z1109ED7D(subproduct_1)), () => loadSubproductDefinitions(globalDeps.ClientNr), locale, globalDeps.IsAdminUser)));
                }
                case 9: {
                    return singleton((children_9 = [warning("404 - Not Found".split(""))], react.createElement("div", {}, ...children_9)));
                }
                default: {
                    return singleton(react.createElement(react.Fragment, {}));
                }
            }
        }))))));
        subscriptionDetailsSectionHtml = react.createElement("div", {
            className: "subscriptions__container",
        }, ...children_11);
    }
    else {
        subscriptionDetailsSectionHtml = react.createElement(react.Fragment, {});
    }
    let createSubscriptionModalHtml;
    const matchValue_8 = [model_1.OpenModal, contractTypesLoadState];
    let pattern_matching_result_3;
    if (matchValue_8[0].tag === 1) {
        if (matchValue_8[1].tag === 2) {
            pattern_matching_result_3 = 0;
        }
        else {
            pattern_matching_result_3 = 1;
        }
    }
    else {
        pattern_matching_result_3 = 1;
    }
    switch (pattern_matching_result_3) {
        case 0: {
            createSubscriptionModalHtml = renderCreateSubscriptionModal(new CreateSubscriptionProps(() => {
                dispatch(new SubscriptionsMsg(10, new Modal(0)));
            }, locale, (globalDeps.ClientNr === 45619) ? "NEJ" : (void 0), sortBy((contractType_2) => contractType_2.Display, fold((acc, key_3, curr) => cons(curr, acc), empty(), matchValue_8[1].fields[0]), {
                Compare: comparePrimitives,
            }), (dto) => saveContract(globalDeps.ClientNr, model_1.InvoiceeDetails.InvoiceeNr, dto), () => {
                dispatch(new SubscriptionsMsg(2));
            }, (contractNr_9) => {
                dispatch(new SubscriptionsMsg(5, toArray(formatUrl(RouterModule_urlSegments(window.location.hash, 1), singleton_1(toString(model_1.InvoiceeDetails.InvoiceeNr)), ofArray(["Subscriptions", int32ToString(contractNr_9)])))));
            }));
            break;
        }
        case 1: {
            createSubscriptionModalHtml = react.createElement(react.Fragment, {});
            break;
        }
    }
    let numberInfoBoxHtml;
    const matchValue_10 = model_1.NumberInfoBox;
    if (isEmpty(matchValue_10)) {
        numberInfoBoxHtml = react.createElement(react.Fragment, {});
    }
    else {
        const uniqueNumbers = map_1((number) => {
            const simCardIconHtml = renderSimCardIcon(getTranslation, number.NumberStatus);
            const numberStr = (number.NumberFrom === number.NumberTo) ? number.NumberFrom : toText(printf("%s - %s"))(number.NumberFrom)(number.NumberTo);
            const children_17 = [simCardIconHtml, react.createElement("span", {
                className: "ml-2",
            }, numberStr)];
            return react.createElement("div", {
                className: "d-flex align-items-center",
            }, ...children_17);
        }, sortBy((n_1) => [n_1.NumberStatus, n_1.NumberFrom.length], List_distinctBy((n) => [n.NumberFrom, n.NumberTo], matchValue_10, {
            Equals: equalArrays,
            GetHashCode: arrayHash,
        }), {
            Compare: compareArrays,
        }));
        const bodyHtml = react.createElement("div", {
            className: "d-flex flex-column align-items-center color-black mb-3",
        }, ...uniqueNumbers);
        numberInfoBoxHtml = modal(true, render_2(getTranslation("Common.PhoneNumbers"), bodyHtml, new MessageType(0), getTranslation("CustomerContract.Invoicee.Subscriptions.Close"), (_arg_4) => {
            dispatch(new SubscriptionsMsg(17));
        }));
    }
    let contractListHtml;
    const finalLoadState = LoadState_zip(model_1.Contracts, contractTypesLoadState);
    switch (finalLoadState.tag) {
        case 1: {
            contractListHtml = dotsLoading;
            break;
        }
        case 3: {
            contractListHtml = error(finalLoadState.fields[0].split(""));
            break;
        }
        case 2: {
            contractListHtml = renderContractList(new ContractListProps(model_1.CurrentSubscriptionContractNr, model_1.GlobalDependencies.ClientConfig.IsTelecom, model_1.SubscriptionListPhoneNumbers, model_1.PendingPhoneNumbers, finalLoadState.fields[0][0], finalLoadState.fields[0][1], model_1.ShowCancelledSubscriptions, (arg_7) => {
                dispatch(new SubscriptionsMsg(5, arg_7));
            }, (arg_9) => {
                dispatch(new SubscriptionsMsg(16, arg_9));
            }));
            break;
        }
        default: {
            contractListHtml = react.createElement(react.Fragment, {});
        }
    }
    const children_24 = [(children_22 = [renderSwitchAndButtonHtml(new SwitchAndButtonProps(model_1.ShowCancelledSubscriptions, () => {
        dispatch(new SubscriptionsMsg(10, new Modal(1)));
    }, () => {
        dispatch(new SubscriptionsMsg(15));
    })), contractListHtml, numberInfoBoxHtml], react.createElement("div", {
        className: "subscriptions__main-container",
    }, ...children_22)), subscriptionDetailsSectionHtml, createSubscriptionModalHtml];
    return react.createElement("div", {
        className: "subscriptions",
    }, ...children_24);
}, "Subscriptions", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Subscriptions\\View.fs", 925);

